module.exports = __webpack_public_path__ + "static/media/hammock-seat.730f9ead.jpg";